var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "explore-filter-bar"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('ul', {
    staticClass: "filters"
  }, _vm._l(_vm.filters, function (filter, key) {
    return _c('li', {
      key: key,
      staticClass: "item",
      class: {
        actived: _vm.selected === key
      },
      on: {
        "click": function click($event) {
          return _vm.itemClickHandler(key, filter);
        }
      }
    }, [_vm._v("\n            " + _vm._s(filter))]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };